import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReceivedInvitationsComponent } from './received-invitations.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RadiatorSchematicModule } from 'src/app/components/radiator-schematic/radiator-schematic.module';



@NgModule({
  declarations: [ReceivedInvitationsComponent],
  imports: [
    CommonModule, SharedModule, RadiatorSchematicModule
  ],
  exports: [ReceivedInvitationsComponent]
})
export class ReceivedInvitationsModule { }
